import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

import { useLocation } from "react-router-dom";
import {
  getCrewInfoById,
  getCrews,
  updateEmployeeCrew,
  DeleteEmployeeCrew,
} from "../../../../services/RHService/CrewService";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
const EmployeebyCrew = () => {
  //variables
  const [showModifyform, setShowModifyform] = useState(false);
  const handleCloseModifyform = () => setShowModifyform(false);
  const location = useLocation();
  const idEquipe = new URLSearchParams(location.search).get("idEquipe");
  const [crewDetail, setCrewDetail] = useState();
  const [crewNames, setCrewNames] = useState([]);
  const [selecteEmpl, setSelectedEmpl] = useState([]);
  const [crewError, setCrewError] = useState("");

  const handleShowModifyform = (empl) => {
    setSelectedEmpl(empl);
    setShowModifyform(true);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const resp = await getCrewInfoById(idEquipe);

    setCrewDetail(resp.data);
  };
  const handleDelete = async (idEquipe) => {
    await DeleteEmployeeCrew(idEquipe, setCrewDetail, crewDetail);
  };
  //colonnes de tableau
  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "nomprenom",
      text: "Personnel",
      formatter: (cell, row) => `${row.firstName} ${row.lastName}`,
    },
    { dataField: "cin", text: "CIN" },
    { dataField: "phone", text: "Mobile" },
    { dataField: "email", text: "Email" },

    {
      dataField: "actions",
      text: "Actions",
      headerStyle: { width: "170px" },
      csvExport: false,
      formatter: (cell, row) => {
        return (
          <div className="center" style={{ display: "flex" }}>
            <Button
              style={{
                "background-color": "#000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleShowModifyform(row);
              }}
            >
              <i className="fa-solid fa-pencil"></i>
            </Button>

            <Button
              className="mx-2"
              style={{
                "background-color": "#cc0000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleDelete(row.id);
              }}
            >
              <i className="fa-solid fa-trash-can"></i>
            </Button>
          </div>
        );
      },
    },
  ];
  // const fetchCrewNames = async () => {
  //   try {
  //     const names = await getCrews(getCurrentUserId());
  //     if (names.data?.success) {
  //       setCrewNames(names.data?.success);
  //     } else if (names.error) {
  //       throw new Error(names.error);
  //     }
  //   } catch (error) {
  //     console.error(`Failed to fetch crew names: ${error}`);
  //   }
  // };
  // useEffect(() => {
  //   fetchCrewNames();
  // }, [fetchCrewNames]);

  const handleUpdate = async (event) => {
    event.preventDefault();

    if (!selecteEmpl.idEquipe || selecteEmpl.idEquipe === 0) {
      setCrewError("Veuillez saisir une equipe");
    } else {
      setCrewError("");
      try {
        console.log(selecteEmpl);
        const response = await updateEmployeeCrew(selecteEmpl.id, selecteEmpl);
        console.log(response);
        if (response.data) {
          fetchData();
          handleCloseModifyform();
        }
      } catch (error) {
        alert(error.message);
      }
    }
  };
  return (
    <div class="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider keyField="id" columns={columns}>
        {(props) => (
          <div>
            {/* Modal Modifie d'affectation d'un personnel a une equipe */}
            <Modal
              show={showModifyform}
              onHide={handleCloseModifyform}
              size="md"
            >
              <Modal.Header closeButton>
                <Modal.Title>Modifier l'équipe de personnel</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleUpdate}>
                  <Container>
                    <Row>
                      <Col xs={12} md={12}>
                        <div className="form-group">
                          <Form.Label>Personnel</Form.Label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            disabled
                            name="id"
                            onChange={(e) =>
                              setSelectedEmpl({
                                ...selecteEmpl,
                                id: e.target.value,
                              })
                            }
                            value={
                              selecteEmpl
                                ? selecteEmpl.firstName +
                                  " " +
                                  selecteEmpl.lastName
                                : ""
                            }
                          />
                        </div>

                        <Form.Group className="form-group">
                          <label for="exampleSelectBorder">Equipe </label>
                          <select
                            className="custom-select form-control-border"
                            name="idEquipe"
                            value={selecteEmpl ? selecteEmpl.idEquipe : 0}
                            onChange={(e) =>
                              setSelectedEmpl({
                                ...selecteEmpl,
                                idEquipe: e.target.value,
                              })
                            }
                          >
                            {/* {crewNames.map((crewName) => (
                              <option
                                key={crewName.idEquipe}
                                value={crewName.idEquipe}
                              >
                                {crewName.nomEquipe}
                              </option>
                            ))} */}
                          </select>
                        </Form.Group>
                        {crewError && (
                          <p style={{ color: "red" }}>{crewError}</p>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModifyform}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleUpdate}>
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Modal d'affectation d'un personnel a une equipe */}
            {/* header */}
            <div className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h1 className="m-0">Liste des personnels</h1>
                  </div>
                  <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-right">
                      <li className="breadcrumb-item">
                        <i class="fa-solid fa-house"></i>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/crewList">Liste des équipes</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        Employées/{crewDetail ? crewDetail.nomEquipe : ""}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            {/* body */}
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div className="col-md-3">
                          <strong className="center">Nom d'équipe</strong>
                          <br></br>
                          {crewDetail ? crewDetail.nomEquipe : ""}
                        </div>
                        <div className="col-md-3">
                          <strong className="center">Chef d'équipe</strong>
                          <br></br>
                          {crewDetail
                            ? crewDetail.firstname + " " + crewDetail.lastname
                            : ""}{" "}
                        </div>

                        <div className="col-md-3">
                          <strong className="center">Email</strong>
                          <br></br>
                          {crewDetail ? crewDetail.email : ""}{" "}
                        </div>
                        <div className="col-md-3">
                          <strong className="center">Nombre d'Employés</strong>
                          <br></br>
                          {crewDetail ? crewDetail.nbEmployeeByCrew : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div className="card-header">
                      <div className="card-title">Horaire</div>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div className="col-md-3 text-center">
                          <strong className="center">Date Début</strong>
                          <br></br>
                          {crewDetail
                            ? crewDetail.dateDeb !== null
                              ? crewDetail.dateDeb
                              : "-"
                            : ""}
                        </div>
                        <div className="col-md-3 text-center">
                          <strong className="center">Date Fin</strong>
                          <br></br>
                          {crewDetail
                            ? crewDetail.dateFin !== null
                              ? crewDetail.dateFin
                              : "-"
                            : ""}
                        </div>

                        <div className="col-md-3 text-center">
                          <strong className="center">Heure Début</strong>
                          <br></br>
                          {crewDetail
                            ? crewDetail.heureDeb !== null
                              ? crewDetail.heureDeb
                              : "-"
                            : ""}
                        </div>
                        <div className="col-md-3 text-center">
                          <strong className="center">Heure Fin</strong>
                          <br></br>
                          {crewDetail
                            ? crewDetail.heureFin !== null
                              ? crewDetail.heureFin
                              : "-"
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      {/* table */}
                      <BootstrapTable
                        {...props.baseProps}
                        data={crewDetail ? crewDetail.employees : ""}
                        columns={columns}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default EmployeebyCrew;
